// eslint-disable-next-line import/no-cycle
import {
  ConfigurationPanelStructure,
  ConfigurationPanelStructureItemEnum,
  TemplateStructureEnum,
  TabItem,
  AppearEffectEnum,
  ComponentNameEnum,
  StepperSignEnum,
  TextAlignValueEnum, Property,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import minimalHeightFieldConfig from '@/components/template-builder/config/fields/minimal-height-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import getWidthFieldConfig from '@/components/template-builder/config/fields/width-config';
// eslint-disable-next-line import/no-cycle
import {
  cleanCssByProperty,
  setClass,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setCssPropertyWithImportant,
  setCssPropertyWithImportantAndRemoveIfZero,
  setCssButtonWidthProperty,
  setMediaDisplay,
  toggleClassAndRemoveFromChild,
  toggleClass,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getClassByName,
  getCssPropertyByName,
  hasClass,
  hasClassElementAndChild,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getDisplayFieldConfig from '@/components/template-builder/config/fields/display-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import itemsVerticalAlignFieldConfig from '@/components/template-builder/config/fields/items-vertical-align-config';
// eslint-disable-next-line import/no-cycle
import getDropdownFieldConfig from '@/components/template-builder/config/fields/dropdown-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import fontFieldConfig from '@/components/template-builder/config/fields/font-config';
// eslint-disable-next-line import/no-cycle
import getTextAlignFieldConfig from '@/components/template-builder/config/fields/text-align-config';
// eslint-disable-next-line import/no-cycle
import lineHeightFieldConfig from '@/components/template-builder/config/fields/line-height-config';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import textStylesFieldConfig from '@/components/template-builder/config/fields/text-styles-config';
// eslint-disable-next-line import/no-cycle
import { setDivAlignmentClass } from '@/components/template-builder/setters/div-alignment';
// eslint-disable-next-line import/no-cycle
import divAlignmentFieldConfig from '@/components/template-builder/config/fields/div-alignment-config';
// eslint-disable-next-line import/no-cycle
import getBorderRadiusFieldConfig from '@/components/template-builder/config/fields/border-radius-config';
// eslint-disable-next-line import/no-cycle
import getElementAlignFieldConfig from '@/components/template-builder/config/fields/element-align-config';
// eslint-disable-next-line import/no-cycle
import { getDisplayButtonWidthFieldConfig } from '@/components/template-builder/config/fields/button-width-config';
// eslint-disable-next-line import/no-cycle
import { restoreSmartListsOriginalCode } from '@/composables/template-editor/TemplateEditor';
// eslint-disable-next-line import/no-cycle
import {
  refreshSmartProductList,
  restoreVoucherButtons,
  switchVoucherButtonsAndCodes,
  toggleFormFieldsError,
} from '@/components/template-builder/callbacks';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import fontSizeFieldConfig from '@/components/template-builder/config/fields/font-size-config';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';

export const pageTabItemConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.PAGE,
  label: 'templateBuilder.configs.page',
  tabPanel: {
    label: 'templateBuilder.configs.page',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.pageStyles',
        selector: 'body #spm_body',
        items: [
          {
            label: 'templateBuilder.fields.cssReset',
            selector: '#spm_body',
            properties: [
              {
                name: 'spm_css_reset',
                getter: hasClass,
                setters: [toggleClass],
              },
            ],
            ...getDisplayFieldConfig('spm_css_reset', ''),
            displayToggle: false,
          },
          {
            label: 'templateBuilder.fields.backgroundColor',
            selector:
              '#spm_body.spm_popin #spm_content, #spm_body #spm_content',
            properties: [
              {
                name: 'background',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            ...getColorFieldConfig('#ffffff', true, true),
            displayToggle: true,
          },
          {
            label: 'templateBuilder.fields.borders',
            selector: '#spm_body #spm_content',
            properties: [
              {
                name: 'border-color',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-style',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-width',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'border-top-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-top-width',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-top-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-bottom-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-bottom-width',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-bottom-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-left-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-left-width',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-left-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-right-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-right-width',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-right-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            ...bordersFieldConfig,
          },
          {
            label: 'templateBuilder.fields.verticalAlignment',
            selector: '#spm_body #spm_content',
            properties: [
              {
                name: 'align-items',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            ...itemsVerticalAlignFieldConfig,
            displayToggle: false,
          },
          {
            label: 'templateBuilder.fields.appearEffect',
            selector: '#spm_body',
            properties: [
              {
                name: 'spmEffect_',
                getter: getClassByName,
                setters: [setClass],
              },
            ],
            ...getDropdownFieldConfig(
              Object.values(AppearEffectEnum).map((effect) => ({
                label: effect,
                value: effect,
              })),
              AppearEffectEnum.NONE,
            ),
            displayToggle: false,
          },
          {
            label: 'templateBuilder.fields.width',
            selector: '#spm_body #spm_content',
            properties: [
              {
                name: 'width',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'min-width',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            ...getWidthFieldConfig(50),
            displayToggle: false,
          },
          {
            label: 'templateBuilder.fields.minimalHeight',
            selector: '#spm_body #spm_content',
            properties: [
              {
                name: 'min-height',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            ...minimalHeightFieldConfig,
            displayToggle: false,
          },
          {
            label: 'templateBuilder.fields.responsiveRow',
            selector: '#spm_body #spm_content .spm_row',
            displayToggle: false,
            properties: [
              {
                // eslint-disable-next-line max-len
                name: 'spm_responsive',
                getter: hasClassElementAndChild,
                setters: [toggleClassAndRemoveFromChild],
                preCallbacks: [restoreSmartListsOriginalCode],
                callbacks: [refreshSmartProductList],
              },
            ],
            ...getDisplayFieldConfig('spm_responsive', ''),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.pageMargins',
        selector: 'body table#spm_body',
        items: [
          {
            label: 'templateBuilder.fields.externalMargins',
            selector: '#spm_body #spm_content',
            properties: [
              {
                name: 'margin-top',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'margin-bottom',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'margin-left',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'margin-right',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('margin').options,
              ...getHorizontalSpacesFieldConfig('margin').options,
            },
          },
          {
            label: 'templateBuilder.fields.contentInnerMargins',
            selector: '#spm_body #spm_content',
            properties: [
              {
                name: 'padding-top',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-bottom',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-left',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-right',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig('padding').options,
            },
          },
          {
            label: 'templateBuilder.fields.lineInnerMargins',
            selector: '#spm_body .spm_row',
            properties: [
              {
                name: 'padding-top',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-bottom',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-left',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-right',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig('padding').options,
            },
          },
          {
            label: 'templateBuilder.fields.columnInnerMargins',
            selector: '#spm_body .spm_column',
            properties: [
              {
                name: 'padding-top',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-bottom',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-left',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-right',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig().options,
            },
          },
          {
            label: 'templateBuilder.fields.widgetInnerMargins',
            selector: '#spm_body .spm_widget',
            properties: [
              {
                name: 'padding-top',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-bottom',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-left',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-right',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig().options,
            },
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.pageTextsAndTitles',
        scrollable: true,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageTexts',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th',
                  properties: [
                    {
                      name: 'font-family',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.textAlign',
                  selector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th',
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th',
                  properties: [
                    {
                      name: 'line-height',
                      getter: getCssPropertyByName,
                      setters: [cleanCssByProperty, setCssProperty],
                    },
                  ],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th',
                  properties: [
                    {
                      name: 'letter-spacing',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageLinks',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.color',
                  selector: '{SELECTOR} a:not(.spm_button), {SELECTOR} a:not(.spm_button):hover, '
                    + '{SELECTOR} a:not(.spm_button):visited, {SELECTOR} a:not(.spm_button):active, '
                    + '{SELECTOR} a:not(.spm_button):focus',
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#333333'),
                  options: {
                    defaultValue: '#2795b6',
                  },
                },
                {
                  label: 'templateBuilder.fields.style',
                  selector: '{SELECTOR} a:not(.spm_button), {SELECTOR} a:not(.spm_button):hover, '
                    + '{SELECTOR} a:not(.spm_button):visited, {SELECTOR} a:not(.spm_button):active, '
                    + '{SELECTOR} a:not(.spm_button):focus',
                  properties: [
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...textStylesFieldConfig,
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageLinksHover',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.color',
                  selector: '{SELECTOR} a:not(.spm_button):hover',
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#333333'),
                },
                {
                  label: 'templateBuilder.fields.style',
                  selector: '{SELECTOR} a:not(.spm_button):hover',
                  properties: [
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...textStylesFieldConfig,
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.title1',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                  properties: [
                    {
                      name: 'font-family',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.titleMarginVertical',
                  selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.titleMarginHorizontal',
                  selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                  properties: [
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector:
                    '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1, {SELECTOR} h1.spm_product_list_title',
                  properties: [
                    {
                      name: 'line-height',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                  properties: [
                    {
                      name: 'letter-spacing',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.titleAlign',
                  selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.title2',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                  properties: [
                    {
                      name: 'font-family',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.titleMarginVertical',
                  selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.titleMarginHorizontal',
                  selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                  properties: [
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                  properties: [
                    {
                      name: 'line-height',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                  properties: [
                    {
                      name: 'letter-spacing',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.titleAlign',
                  selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.title3',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                  properties: [
                    {
                      name: 'font-family',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.titleMarginVertical',
                  selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.titleMarginHorizontal',
                  selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                  properties: [
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                  properties: [
                    {
                      name: 'line-height',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                  properties: [
                    {
                      name: 'letter-spacing',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.titleAlign',
                  selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.title4',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                  properties: [
                    {
                      name: 'font-family',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.titleMarginVertical',
                  selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin', 10),
                },
                {
                  label: 'templateBuilder.fields.titleMarginHorizontal',
                  selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                  properties: [
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                  properties: [
                    {
                      name: 'line-height',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                  properties: [
                    {
                      name: 'letter-spacing',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.titleAlign',
                  selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(),
                },
              ],
            },
          ],
        },
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.pageInputs',
        selector: '#spm_body #spm_content',
        isVisible: () => {
          const template = getTemplateIframeDocument();
          if (!template) return false;
          const spmBody = template.querySelector('body #spm_body');
          return spmBody?.classList.contains('spm_display_V3') ?? true;
        },
        items: [
          {
            label: 'templateBuilder.fields.width',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [
              { name: 'width', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'max-width', getter: getCssPropertyByName, setters: [setCssProperty] },
            ],
            ...getWidthFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.alignment',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [{ name: 'spm_div_align_', getter: getClassByName, setters: [setDivAlignmentClass] }],
            ...divAlignmentFieldConfig,
          },
          {
            label: 'templateBuilder.fields.font',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [
              { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
            ],
            ...fontFieldConfig,
          },
          {
            label: 'templateBuilder.fields.textAlign',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [{ name: 'text-align', getter: getCssPropertyByName, setters: [setCssProperty] }],
            ...getTextAlignFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.backgroundColor',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [{
              name: 'background',
              getter: getCssPropertyByName,
              setters: [setCssProperty],
            }],
            ...getColorFieldConfig('#ECECEC', false, true),
          },
          {
            label: 'templateBuilder.fields.contours',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [{ name: 'border-radius', getter: getCssPropertyByName, setters: [setCssProperty] }],
            ...getBorderRadiusFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.borders',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [
              { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-style', getter: getCssPropertyByName, setters: [] },
              { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
            ],
            ...bordersFieldConfig,
          },
          {
            label: 'templateBuilder.fields.spaceWithinButton',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig().options,
            },
          },
          {
            label: 'templateBuilder.fields.titleMarginVertical',
            selector: '{SELECTOR} .spm_form_field .spm_form_input',
            properties: [
              { name: 'margin-top', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'margin-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
            ],
            ...getVerticalSpacesFieldConfig('margin'),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        label: 'templateBuilder.configs.pageInputs',
        tabItemType: TemplateStructureEnum.GROUP,
        anchorId: 'pageInputs',
        isVisible: () => {
          const template = getTemplateIframeDocument();
          if (!template) return false;
          const spmBody = template.querySelector('body #spm_body');
          return spmBody?.classList.contains('spm_display_V4') ?? true;
        },
        onTabUnmount: () => {
          toggleFormFieldsError(false);
        },
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.baseStyles',
              selector: '#spm_body.spm_display_V4 #spm_content',
              onTabActivate: () => {
                toggleFormFieldsError(false);
              },
              items: [
                {
                  label: 'templateBuilder.fields.width',
                  selector: '{SELECTOR} .spm_form_field',
                  properties: [
                    {
                      name: 'width',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'max-width',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getWidthFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.alignment',
                  selector:
                    '{SELECTOR} .spm_form_field input, {SELECTOR} .spm_form_field .spm_custom_select__trigger, '
                    + '{SELECTOR} .spm_form_field textarea',
                  properties: [
                    {
                      name: 'spm_div_align_',
                      getter: getClassByName,
                      setters: [setDivAlignmentClass],
                    },
                  ],
                  ...divAlignmentFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.font',
                  selector:
                    '{SELECTOR} .spm_form_field input, {SELECTOR} .spm_form_field .spm_custom_select__trigger, '
                    + '{SELECTOR} .spm_form_field textarea, '
                    + '{SELECTOR} .spm_form_field.spm_label_inside input::placeholder, '
                    + '{SELECTOR} .spm_form_field.spm_label_inside textarea::placeholder',
                  properties: [
                    {
                      name: 'font-family',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.textAlign',
                  selector:
                    '{SELECTOR} .spm_form_field input, {SELECTOR} .spm_form_field .spm_custom_select__trigger, '
                    + '{SELECTOR} .spm_form_field textarea, '
                    + '{SELECTOR} .spm_form_field.spm_label_inside input::placeholder, '
                    + '{SELECTOR} .spm_form_field.spm_label_inside textarea::placeholder',
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.backgroundColor',
                  selector:
                    '{SELECTOR} .spm_form_field input, {SELECTOR} .spm_form_field .spm_custom_select__trigger, '
                    + '{SELECTOR} .spm_form_field textarea',
                  properties: [
                    {
                      name: 'background',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#ECECEC', false, true),
                },
                {
                  label: 'templateBuilder.fields.contours',
                  selector:
                    '{SELECTOR} .spm_form_field input, {SELECTOR} .spm_form_field .spm_custom_select__trigger, '
                    + '{SELECTOR} .spm_form_field textarea',
                  properties: [
                    {
                      name: 'border-radius',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getBorderRadiusFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector:
                    '{SELECTOR} .spm_form_field input, {SELECTOR} .spm_form_field .spm_custom_select__trigger, '
                    + '{SELECTOR} .spm_form_field textarea',
                  properties: [
                    {
                      name: 'border-color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-style',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-width',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-bottom-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-bottom-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-bottom-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-top-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-left-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-right-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                  ],
                  ...bordersFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceWithinInput',
                  selector:
                    '{SELECTOR} .spm_form_field input, {SELECTOR} .spm_form_field .spm_custom_select__trigger, '
                    + '{SELECTOR} .spm_form_field textarea',
                  properties: [
                    {
                      name: 'padding-top',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-left',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-right',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  options: {
                    ...getVerticalSpacesFieldConfig('padding').options,
                    ...getHorizontalSpacesFieldConfig().options,
                  },
                },
                {
                  label: 'templateBuilder.fields.inputMarginVertical',
                  selector:
                    '{SELECTOR} .spm_form_field input, {SELECTOR} .spm_form_field .spm_custom_select__trigger, '
                    + '{SELECTOR} .spm_form_field textarea',
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin'),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.errorStyles',
              selector: '#spm_body.spm_display_V4 #spm_content',
              onTabActivate: () => {
                toggleFormFieldsError(true);
              },
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} .spm_form_field input.spm_error, {SELECTOR} .spm_form_field select.spm_error, {SELECTOR} .spm_form_field textarea.spm_error, '
                    + '{SELECTOR} .spm_custom_select__trigger.spm_error, '
                    + '{SELECTOR} .spm_widget_input_phone__country_select.spm_custom_select .spm_custom_select__trigger.spm_error',
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.backgroundColor',
                  selector: '{SELECTOR} .spm_form_field input.spm_error, {SELECTOR} .spm_form_field select.spm_error, {SELECTOR} .spm_form_field textarea.spm_error, '
                    + '{SELECTOR} .spm_custom_select__trigger.spm_error, '
                    + '{SELECTOR} .spm_widget_input_phone__country_select.spm_custom_select .spm_custom_select__trigger.spm_error',
                  properties: [
                    {
                      name: 'background',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig(undefined, false, true),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR} .spm_form_field input.spm_error, {SELECTOR} .spm_form_field select.spm_error, {SELECTOR} .spm_form_field textarea.spm_error, '
                    + '{SELECTOR} .spm_custom_select__trigger.spm_error, '
                    + '{SELECTOR} .spm_widget_input_phone__country_select.spm_custom_select .spm_custom_select__trigger.spm_error',
                  properties: [
                    {
                      name: 'border-color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-style',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-width',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-bottom-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-bottom-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-bottom-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-top-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-left-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-right-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                  ],
                  ...bordersFieldConfig,
                },
              ],
            },
          ],
        },
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        label: 'templateBuilder.configs.pageButtons',
        tabItemType: TemplateStructureEnum.GROUP,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageButtons',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.width',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'width',
                      getter: getCssPropertyByName,
                      setters: [setCssButtonWidthProperty, (selector: string) => {
                        setCssPropertyWithImportant(selector, { name: 'display', value: 'inline-block' } as Property);
                      }],
                    },
                  ],
                  ...getDisplayButtonWidthFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.alignment',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'spm_div_align_',
                      getter: getClassByName,
                      setters: [setDivAlignmentClass],
                    },
                  ],
                  ...divAlignmentFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.contours',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'border-radius',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getBorderRadiusFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'border-color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-style',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-width',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-bottom-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-bottom-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-bottom-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-top-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-left-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-right-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                  ],
                  ...bordersFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.backgroundColor',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'background',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#ECECEC', false, true),
                  options: {
                    defaultValue: '#E0E0E0',
                  },
                },
                {
                  label: 'templateBuilder.fields.font',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'font-family',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'line-height',
                      getter: getCssPropertyByName,
                      setters: [cleanCssByProperty, setCssProperty],
                    },
                  ],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.textAlign',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'letter-spacing',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.spaceWithinButton',
                  selector: '#spm_body #spm_content a.spm_button, #spm_body #spm_content a.spm_button:hover, '
                    + '#spm_body #spm_content a.spm_button:visited, #spm_body #spm_content a.spm_button:active, '
                    + '#spm_body #spm_content a.spm_button:focus, #spm_body #spm_content a.spm_button:disabled',
                  properties: [
                    {
                      name: 'padding-top',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-left',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-right',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  options: {
                    ...getVerticalSpacesFieldConfig('padding').options,
                    ...getHorizontalSpacesFieldConfig().options,
                  },
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageButtonsHover',
              selector: '#spm_body #spm_content',
              items: [
                {
                  label: 'templateBuilder.fields.backgroundColor',
                  selector: '#spm_body #spm_content a.spm_button:hover',
                  properties: [
                    {
                      name: 'background',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#E0E0E0', false, true),
                },
                {
                  label: 'templateBuilder.fields.color',
                  selector: '#spm_body #spm_content a.spm_button:hover',
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#333333'),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '#spm_body #spm_content a.spm_button:hover',
                  properties: [
                    {
                      name: 'border-color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-style',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-width',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-bottom-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-bottom-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-bottom-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-top-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-left-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-right-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                  ],
                  ...bordersFieldConfig,
                },
              ],
            },
          ],
        },
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        label: 'templateBuilder.configs.pageVouchers',
        tabItemType: TemplateStructureEnum.GROUP,
        onTabUnmount: () => {
          restoreVoucherButtons();
        },
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.voucherButtonStyles',
              selector: '#spm_body #spm_content',
              onTabActivate: () => {
                switchVoucherButtonsAndCodes();
              },
              items: [
                {
                  label: 'templateBuilder.fields.iconColor',
                  selector:
                    '{SELECTOR} .spm_voucher_icon, {SELECTOR} .spm_voucher_icon_code',
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyWithImportant],
                    },
                  ],
                  ...getColorFieldConfig('#333333'),
                },
                {
                  label: 'templateBuilder.fields.buttonWidth',
                  selector: '{SELECTOR} .spm_generate_voucher_button',
                  properties: [
                    {
                      name: 'width',
                      getter: getCssPropertyByName,
                      setters: [setCssButtonWidthProperty],
                    },
                  ],
                  ...getDisplayButtonWidthFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.buttonAlignment',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button, {SELECTOR} .spm_container_voucher_code',
                  properties: [
                    {
                      name: 'spm_div_align_',
                      getter: getClassByName,
                      setters: [setClass],
                    },
                  ],
                  ...getElementAlignFieldConfig('spm_div_align_'),
                },
                {
                  label: 'templateBuilder.fields.contours',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_container_voucher_code a.spm_button',
                  properties: [
                    {
                      name: 'border-radius',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getBorderRadiusFieldConfig('5px'),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button',
                  properties: [
                    {
                      name: 'border-color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-style',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-width',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-bottom-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-bottom-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-bottom-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-top-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-left-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-right-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                  ],
                  ...bordersFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.buttonBackgroundColor',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button',
                  properties: [
                    {
                      name: 'background',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#ECECEC', false, true),
                },
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button',
                  properties: [
                    {
                      name: 'font-family',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyWithImportant],
                    },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.contentAlignment',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(TextAlignValueEnum.CENTER),
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [
                    {
                      name: 'letter-spacing',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.internalMargins',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [
                    {
                      name: 'padding-top',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-left',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'padding-right',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  options: {
                    ...getVerticalSpacesFieldConfig('padding').options,
                    ...getHorizontalSpacesFieldConfig('padding').options,
                  },
                },
                {
                  label: 'templateBuilder.fields.mediaDisplay',
                  selector: '{SELECTOR} ',
                  properties: [
                    {
                      name: 'show-for-',
                      getter: getClassByName,
                      setters: [setMediaDisplay],
                    },
                  ],
                  disableHandler: (selector: string) => getTemplateIframeDocument()?.body.getAttribute(
                      HIDE_MOBILE_ATTRIBUTE
                    ) === 'true' || isMediaDisplayAlreadyRestricted(selector),
                  disableMessage:
                    'templateBuilder.fields.warningMessages.disabledMobileDesign',
                  ...mediaDisplayFieldConfig,
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.voucherCodeStyles',
              selector: '#spm_body #spm_content',
              onTabActivate: () => {
                switchVoucherButtonsAndCodes();
              },
              items: [
                {
                  label: 'templateBuilder.fields.iconColor',
                  selector:
                    '{SELECTOR} .spm_container_voucher_code .spm_voucher_icon_code',
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyWithImportant],
                    },
                  ],
                  ...getColorFieldConfig('#333333'),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [
                    {
                      name: 'border-color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-style',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-width',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-bottom-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-bottom-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-bottom-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-top-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-left-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-right-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                  ],
                  ...bordersFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.backgroundColor',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [
                    {
                      name: 'background',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#ECECEC', false, true),
                },
                {
                  label: 'templateBuilder.fields.codeColor',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyWithImportant],
                    },
                  ],
                  ...getColorFieldConfig('#000000'),
                },
                {
                  label: 'templateBuilder.fields.codeFontSize',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [
                    {
                      name: 'font-size',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...fontSizeFieldConfig,
                  options: {
                    ...fontSizeFieldConfig.options,
                    px: {
                      ...fontSizeFieldConfig.options.px,
                      defaultValue: 18,
                    },
                  },
                },
                {
                  label: 'templateBuilder.fields.codeStyles',
                  selector:
                    '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [
                    {
                      name: 'font-weight',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'font-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-decoration-line',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'text-transform',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...textStylesFieldConfig,
                },
              ],
            },
          ],
        },
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.separators',
        selector: '#spm_body #spm_content',
        items: [
          {
            label: 'templateBuilder.fields.style',
            selector: '{SELECTOR} .spm_widget_display_separator',
            properties: [
              {
                name: 'border-color',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-width',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'border-style',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-bottom-style',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
              {
                name: 'border-bottom-color',
                getter: getCssPropertyByName,
                setters: [],
              },
              {
                name: 'border-bottom-width',
                getter: getCssPropertyByName,
                setters: [],
              },
            ],
            ...bordersFieldConfig,
          },
          {
            label: 'templateBuilder.fields.width',
            selector: '{SELECTOR} .spm_widget_display_separator',
            properties: [
              {
                name: 'width',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            ...getWidthFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.alignment',
            selector: '{SELECTOR} .spm_widget_display_separator',
            properties: [
              {
                name: 'text-align',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              },
            ],
            ...getElementAlignFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.marginVertical',
            selector: '{SELECTOR} .spm_widget_display_separator',
            properties: [
              {
                name: 'padding-top',
                getter: getCssPropertyByName,
                setters: [setCssPropertyWithImportantAndRemoveIfZero],
              },
              {
                name: 'padding-bottom',
                getter: getCssPropertyByName,
                setters: [setCssPropertyWithImportantAndRemoveIfZero],
              },
            ],
            ...getVerticalSpacesFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.marginHorizontal',
            selector: '{SELECTOR} .spm_widget_display_separator',
            properties: [
              {
                name: 'padding-left',
                getter: getCssPropertyByName,
                setters: [setCssPropertyWithImportantAndRemoveIfZero],
              },
              {
                name: 'padding-right',
                getter: getCssPropertyByName,
                setters: [setCssPropertyWithImportantAndRemoveIfZero],
              },
            ],
            ...getHorizontalSpacesFieldConfig(),
          },
        ],
      },
    ],
  },
};

const pageItemConfig: ConfigurationPanelStructure = {
  items: [pageTabItemConfig],
};

export default pageItemConfig;
